<script setup>
import LinkNotFoundIcon from "../components/icons/LinkNotFound.vue";
import SectionHeader from "../components/texts/SectionHeader.vue";
import BaseView from "./BaseView.vue";
</script>

<template>
    <BaseView>
        <div class="text-center my-16 h-full">
            <LinkNotFoundIcon class="large-icon" />
            <SectionHeader
                label="Sorry, the page you are looking for does not exist."
                class="my-8"
                :show-divider="false"
                :center="true"
            />
            <router-link to="/" replace>Return to Home page</router-link>
        </div>
    </BaseView>
</template>
